__turbopack_context__.v({
  "picture": "SuccessRegister-module__frQwsq__picture",
  "wrapper": "SuccessRegister-module__frQwsq__wrapper",
});
